import { render, staticRenderFns } from "./CapitalCompositionCard.vue?vue&type=template&id=e4655de2&scoped=true&"
import script from "./CapitalCompositionCard.vue?vue&type=script&lang=js&"
export * from "./CapitalCompositionCard.vue?vue&type=script&lang=js&"
import style0 from "./CapitalCompositionCard.vue?vue&type=style&index=0&id=e4655de2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4655de2",
  null
  
)

export default component.exports